import type { FolderList } from '@/api/model/folderModel'
import type {
  RecipientOption,
  RecipientOptionList,
} from '@/api/send_cart/model/sendCartModel'
import type { Mutation } from 'vuex'

import { actionTypes, State } from '.'
import { SubPageEnum, ThirdPageEnum } from './state'

const mutations: { [actionTypes: string]: Mutation<State> } = {
  [actionTypes.SET_ACTIVE_SUB_PAGE](state, page: SubPageEnum | null): void {
    state.activeSubPage = page
  },

  [actionTypes.SET_ACTIVE_THIRD_PAGE](state, page: ThirdPageEnum | null): void {
    state.activeThirdPage = page
  },

  [actionTypes.INITIALIZE_RECIPIENT_MASTER_OPTIONS](
    state,
    options: RecipientOptionList
  ): void {
    state.recipientMasterOptions = [...options]
    state.recipientMasterOptionsBackup = [...options]
  },

  [actionTypes.SELECT_RECIPIENT_MASTER](state, target: RecipientOption): void {
    state.selectedRecipientMaster = target ? { ...target } : null
  },

  [actionTypes.CHANGE_RECIPIENT_MASTER_NAME](state, newList: RecipientOptionList) {
    state.recipientMasterOptions = [...newList]
  },

  [actionTypes.DELETE_RECIPIENT_MASTER](state, list: RecipientOptionList): void {
    state.recipientMasterOptions = [...list]
  },

  [actionTypes.CREATE_RECIPIENT_MASTER](state, newRecipientMaster): void {
    state.recipientMasterOptions = [...state.recipientMasterOptions, newRecipientMaster]
  },

  [actionTypes.SET_FOLDER_LIST](state, list: FolderList): void {
    state.folderList = [...list]
  },

  //登録確認ダイアログ
  [actionTypes.SET_CORPORATE_NUMBER_ADD_SUBMIT_MODAL](state, status: boolean): void {
    state.corporateNumberAddSubmitModal = status
  },

  //新規登録フラグ
  [actionTypes.SET_SUBMIT_FLAG](state: State, flag: string) {
    state.submitFlag = flag
  },

  //新規登録の法人番号
  [actionTypes.SET_NEW_CORPORATE_NUMBER](state: State, newNumber: string) {
    state.newCorporateNumber = newNumber
  },
  //新規登録の法人名
  [actionTypes.SET_NEW_CORPORATE_NAME](state: State, newName: string) {
    state.newCorporateName = newName
  },

  //送信先詳細id
  [actionTypes.SET_RECIPIENT_DETAIL_ID](state: State, id: number) {
    state.recipientDetailId = id
  },

  //選択された法人番号、法人名
  [actionTypes.SET_SELECTED_CORPORATE_NUMBER](state: State, corporateNumber: number) {
    state.selectedCorporateNumber = corporateNumber
  },

  [actionTypes.SET_SELECTED_CORPORATE_NAME](state: State, corporateName: string) {
    state.selectedCorporateName = corporateName
  },

  //初取引先コードか否か
  [actionTypes.SET_IS_FIRST_CLIENT](state: State, status: boolean) {
    state.isFirstClient = status
  },

  //新規登録の取引先コード
  [actionTypes.SET_NEW_CLIENT_CODE](state: State, newCode: string) {
    state.newClientCode = newCode
  },

  //新規登録の取引先名
  [actionTypes.SET_NEW_CLIENT_NAME](state: State, newName: string) {
    state.newClientName = newName
  },

  //選択された取引先
  [actionTypes.SET_SELECTED_CLIENT_CODE](state: State, newCode: string) {
    state.selectedClientCode = newCode
  },

  [actionTypes.SET_SELECTED_CLIENT_NAME](state: State, newName: string) {
    state.selectedClientName = newName
  },

  //新規登録の担当者名
  [actionTypes.SET_NEW_RECIPIENT_USER_NAME](state: State, newName: string) {
    state.newRecipientUserName = newName
  },

  //新規登録の送信先組織
  [actionTypes.SET_NEW_RECIPIENT_DEPARTMENT_NAME](state: State, newName: string) {
    state.newRecipientDepartmentName = newName
  },

  //新規登録のメールアドレス
  [actionTypes.SET_NEW_RECIPIENT_MAIL](state: State, newMail: string) {
    state.newRecipientMail = newMail
  },
}

export default mutations
